import React from "react";
import { Select } from "antd";
import { getWareHouse } from "../service";

const WarehouseSelect = ({ selectProps, changeWarehouseId, showAll }) => {
  const [warehouse, changeWarehouse] = React.useState([]);
  const [currWarehouseId, changeCurrWarehouseId] = React.useState(null);
  React.useEffect(() => {
    requestWareHouse();
  }, []);
  /**
   * 获取库房列表
   */
  const requestWareHouse = async () => {
    const res = await getWareHouse();
    if (res.data) {
      const { data } = res.data;
      if (data && data.length > 0) {
        if (showAll) {
          data.unshift({
            id: null,
            wareHouseName: "全部",
          });
        }
        changeWarehouse(data);
        changeCurrWarehouseId(data[0].id);
        changeWarehouseId(data[0].id);
      }
    }
  };
  return (
    <Select
      key={warehouse}
      value={currWarehouseId}
      onSelect={(value) => {
        changeCurrWarehouseId(value);
        changeWarehouseId(value);
      }}
      {...selectProps}
    >
      {warehouse.map((ele) => (
        <Select.Option key={ele.id} value={ele.id}>
          {ele.wareHouseName}
        </Select.Option>
      ))}
    </Select>
  );
};

export default WarehouseSelect;
